import { render, staticRenderFns } from "./RestablecerPassword.vue?vue&type=template&id=3725c624&"
import script from "./RestablecerPassword.vue?vue&type=script&lang=js&"
export * from "./RestablecerPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports